export const ACTIVE_DEPARTMENT_KEY = "active_department";
export const ACTIVE_DEPARTMENT_EVENT = "active-department-change";

export function getActiveDepartment() {
  try {
    const raw = localStorage.getItem(ACTIVE_DEPARTMENT_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function setActiveDepartment(department) {
  try {
    if (department) {
      localStorage.setItem(ACTIVE_DEPARTMENT_KEY, JSON.stringify(department));
      localStorage.setItem("active_department_id", department.id || "");
      localStorage.setItem("active_department_code", department.code || "");
    } else {
      localStorage.removeItem(ACTIVE_DEPARTMENT_KEY);
      localStorage.removeItem("active_department_id");
      localStorage.removeItem("active_department_code");
    }
  } catch {}

  window.dispatchEvent(new CustomEvent(ACTIVE_DEPARTMENT_EVENT, { detail: department || null }));
}
